import React from 'react';
import { useEffect } from 'react';
import Navbar2 from '../Navbar2';
import PrivacyPolicy from '../PrivacyPolicy';
import Footer from '../Footer';


function PrivacyPolicyPage() {
    useEffect(() => {
        document.title = 'JOBS4US - Privacy Policy';
    }, []);
    return (
        <div>
            <Navbar2 />
            <PrivacyPolicy />
            <Footer />
        </div>
    );
}

export default PrivacyPolicyPage;
